import { createRouter, createWebHistory } from 'vue-router'
import MainRoutes  from './MainRoutes';
import Authroutes from './AuthRoutes';
import { useAuthStore } from '@/store/auth';
import { RouteRecordRaw } from "vue-router";
import { AuthStore } from '@/types/stores';

const getRedirectUrl = () => { 
  const hash = window.location.hash;
  const accessTokenMatch = hash.match(/access_token=([^&]*)/);
  if (accessTokenMatch) {
    const accessToken = accessTokenMatch[1];
    return  `/auth/callback/${accessToken}`;
  }
  return '/auth';
}

const routes: Array<RouteRecordRaw> = [
  MainRoutes,
  Authroutes,
  {
    path: '/',
    redirect : getRedirectUrl()
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/pages/NotFound.vue')
  }
];

const router = createRouter({
  history: createWebHistory(process.env?.VUE_APP_SSNV_BASE_PATH),
  routes
});

router.beforeEach((to, _, next) => {   
  const auth: AuthStore = useAuthStore();
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (to.name && auth.isAuthRequired(to.name.toString()) && !auth.isLoginvalid()) {
      auth.returnUrl = to.fullPath;
      return next('/auth/login');
    } else next();
  } else next();
});

export default router
